// extracted by mini-css-extract-plugin
export default {"desktopQuery":"only screen and (min-width: 960px) and (orientation: landscape)"};